<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Hamutal Bar-Yosef is a well-known Israeli writer, poet, translator and scholar. She was born in a kibbutz. When she was over 40, she wrote her PhD and became a professor of Hebrew literature at Ben-Gurion University. She published 8 scholarly books and 16 books of poetry, winning over 10 major prizes for her poetry. Her poems were translated and published in various languages, including two collections in English: <i class="calibre1">Night, Morning</i> (2017) and <i class="calibre1">The Ladder</i> (2013).</p>
<p class="block_3"> </p>
<p class="block_2">Her collection of stories, <i class="calibre1">Music</i>, won the ASI (Association of Israeli Writers) prize (translated into English as <i class="calibre1">The Wall</i>, 2019). She translated poetry and prose fiction from English, French, Russian and Yiddish. Her prize-winning historical novel <i class="calibre1">The Wealthy</i> has been translated into English (2022) and has received many reviews.</p>
<p class="block_4" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?7bf91b56